import React from "react";
import BADGES from "../../configs/badges";

import * as S from "../../style";

function TripBadge({ status, fullWidth }) {
    const tripStatueBadge = BADGES[status] || BADGES.default;

    return (
        <S.StyledBadge
            color={tripStatueBadge.color}
            fullWidth={fullWidth}
        >
            <b>{tripStatueBadge.title}</b>
        </S.StyledBadge>
    );
}

export default TripBadge;
